/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarSquareRegularCheck from './calendar-square-regular-check-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarSquareRegularCheck {...validProps} />;
}

SvgComponent.iconName = 'calendarSquareRegularCheck';

export const CalendarSquareRegularCheckIcon = svgIconWrapper(SvgComponent);
